/*
 * @Author: your name
 * @Date: 2021-05-26 16:44:33
 * @LastEditTime: 2021-07-17 13:17:32
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \PPTist\src\utils\video.ts
 */

interface AudioSize {
  width: number;
  height: number;
}
  
/**
 * 获取音频的原始宽高
 * @param src 图片地址
 */
export const getAudioSize = (src: string): Promise<AudioSize> => {
  return new Promise(resolve => {
    const audio = document.createElement('audio')
    audio.src = src
    audio.style.opacity = '0'
    document.body.appendChild(audio)
    
    audio.onloadstart = () => {
      const audioWidth = audio.clientWidth
      const audioHeight = audio.clientHeight
      audio.onloadstart = null
      audio.onerror = null

      document.body.removeChild(audio)

      resolve({ width: audioWidth, height: audioHeight })
    }

    audio.onerror = () => {
      audio.onload = null
      audio.onerror = null
    }
  })
}

import axios from 'axios'
/**
 * 读取音频文件的dataURL
 * @param file 音频文件
 */
export const getAudioDataURL = (file: File): Promise<string> => {
  return new Promise(resolve => {
    const reader = new FileReader()
    reader.addEventListener('load', () => {
      const token: any = sessionStorage.getItem('token')

      const config = {
        headers: { 'Authorization': token }
      }
      const param = new FormData()
      param.append('file', file)
      axios.post('https://api.brimfar.online/file/upload/', param, config).then(res => {
        if (res.data.status === 200) {
          resolve('https://api.brimfar.online/static' + res.data.data.relativePath)
        } else {
          alert(res.data.message)
        }
      }).catch((e: any)=>{
        if (e.message.indexOf('403') != '-1') {
          alert('身份信息已过期、请重新登录!')
        }
      })
    })
    reader.readAsBinaryString(file)
  })
}